export type TCardProps = {
  children?: React.ReactNode
}

/**
 * @deprecated Use `Card` (with `CardHeader`/`CardTitle`/`CardDescription`/`CardContent`/`CardFooter`/`CardAction`) from `@alternative/acqua/organisms` instead. acqua's Card is a fuller compound component; the acqua-ui version is being phased out.
 */
export const Card = ({ children }: TCardProps): JSX.Element => (
  <div className='shadow-flat rounded-2xl p-6'>{children}</div>
)
